import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  downloadText: {
    fontWeight: "bold",
  },
  dataText: {
    marginRight: theme.spacing(1),
    fontWeight: "bold",
  },
  refreshButton: {
    color: theme.palette.secondary.main,
  },
  search: {
    flex: 10,
    background: "white",
    borderRadius: "4px",
    marginLeft: "2vw",
    maxWidth: "200px",
    width: 228,
    [theme.breakpoints.down("sm")]: {
      width: 200,
    },
    [theme.breakpoints.down("xs")]: {
      width: 150,
    },
  },
  searchIcon: {
    color: "#E2E2E2",
  },
}))

export default styles
